export default __webpack_public_path__ + "static/media/card-w-about@2x.e8359cdd.png";